import { Button, Card, Modal, Popconfirm, Table, Tag } from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { OrganisationUsers, ProjectMemberApi } from "../../../../api";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { CardBody, Container } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { PlusCircle } from "react-feather";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { LogEvents, LoggerContext } from "../../../../context/logging";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ProjectMembers = (props) => {
  const logger = React.useContext(LoggerContext);

  const [members, setMembers] = useState([]);
  const [totalMembers, setTotalMembers] = useState([]);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  useEffect(() => {
    fetchMembers({ project: props.settings.project.id });
  }, []);
  const fetchMembers = (params = {}) => {
    axios.get(`${ProjectMemberApi}`, { params: { ...params } }).then((res) => {
      const arr = res.data;
      const id = arr.map((each) => {
        return each?.user_organisation?.id;
      });
      setMembers(arr);
      setSelectedRows([]);
      setSelectedRowKeys([]);
      fetchTotalMembers(id);
    });
  };
  const fetchTotalMembers = (id) => {
    axios
      .get(`${OrganisationUsers}`, { params: { user__is_active: true } })
      .then((res) => {
        var arr = res.data?.filter((each) => !id.includes(each.id));
        console.log(arr, id);
        setTotalMembers(arr);
      });
  };
  const addMembers = () => {
    const arr = selectedRowKeys;
    var finalArr = [];
    for (var i = 0; i < arr.length; i++) {
      const formValue = {
        user_organisation: arr[i],
        project: props.settings.project.id,
        status: true,
      };
      finalArr.push(formValue);
    }
    axios
      .post(`${ProjectMemberApi}`, finalArr)
      .then((res) => {
        toast.success("Members added successfully");
        fetchMembers({ project: props.settings.project.id });
      })
      .catch((res) => {
        toast.error("Failed to add Member");
      });
    setModal1Visible(false);
  };
  const onDelete = (id) => {
    axios
      .delete(`${ProjectMemberApi}${id}/`)
      .then((res) => {
        toast.success("Member deleted successfully");
        fetchMembers({ project: props.settings.project.id });
      })
      .catch((res) => {
        console.log(res.response.status, "res");
        if (res.response.status === 405) {
          toast.error(res.response.data);
        } else toast.error("Something went wrong");
      });
  };
  const columns = [
    {
      title: "Name",
      key: "name",
      render: (data) => (
        <span>{data?.user_organisation?.user?.name ?? ""}</span>
      ),
    },
    {
      title: "Email",
      key: "email",
      render: (data) => (
        <span>{data?.user_organisation?.user?.email ?? ""}</span>
      ),
    },
    {
      title: "Designation",
      key: "designation",
      render: (data) => (
        <span>{data?.user_organisation?.user?.designation ?? ""}</span>
      ),
    },
    {
      title: "Department",
      key: "department",
      render: (data) => (
        <span>{data?.user_organisation?.user?.department ?? ""}</span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <Popconfirm
          okText="Yes"
          cancelText="No"
          title="Are you sure to delete?"
          onConfirm={() => onDelete(data.id)}
        >
          <Tag color="error" icon={<DeleteOutlined />}>
            Delete
          </Tag>
        </Popconfirm>
      ),
    },
  ];
  const columnsSub = [
    {
      title: "Name",
      key: "name",
      render: (data) => <span>{data?.user?.name}</span>,
    },
    {
      title: "Email",
      key: "email",
      render: (data) => <span>{data?.user?.email}</span>,
    },
    {
      title: "Designation",
      key: "designation",
      render: (data) => <span>{data?.user?.designation}</span>,
    },
    {
      title: "Department",
      key: "department",
      render: (data) => <span>{data?.user?.department}</span>,
    },
  ];
  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <React.Fragment>
      <Container fluid={true}>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="">
              <H5>All Members</H5>
            </div>
            <span className="d-flex">
              <Button
                onClick={(e) => {
                  logger.log(LogEvents.addProjectMembers, {});

                  setModal1Visible(true);
                }}
                className="btn btn-primary d-flex align-items-center justify-content-center text-white"
              >
                {" "}
                <PlusCircle />
                <div
                  style={{
                    marginLeft: "4px",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                  }}
                >
                  Add Member
                </div>
              </Button>
            </span>
          </div>
          <div className="my-2">
            <Table
              dataSource={members}
              columns={columns}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </div>
        </CardBody>
      </Container>
      <Modal
        title="Add Member"
        centered
        visible={modal1Visible}
        width="70%"
        onCancel={() => {
          setModal1Visible(false);
        }}
        footer={[
          <Button
            key="submit"
            className="btn btn-primary text-white"
            htmlType="submit"
            disabled={selectedRows.length === 0}
            onClick={() => {
              console.log(selectedRowKeys);
              addMembers();
            }}
          >
            Submit
          </Button>,
          <Button
            key="back"
            onClick={() => {
              setModal1Visible(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <Card>
          <Table
            dataSource={totalMembers}
            columns={columnsSub}
            rowKey={(data) => data.id}
            pagination={false}
            scroll={{ y: "65vh" }}
            rowSelection={{ ...rowSelection }}
          />
        </Card>
      </Modal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ProjectMembers);
